import "./RemoveTaskGroup.scss";
import { useTranslation, Trans } from "react-i18next";

function RemoveTaskGroup({
  cancelRemoveTaskGroup,
  removeTaskGroup,
  taskGroupName,
  openTaskCount = 0,
}) {
  const { t } = useTranslation();
  return (
    <div className="remove-task-group-content">
      <div className="modal-title">
        <div>{t("tasks.modals.removeTaskGroup.title")}</div>
      </div>
      <div className="modal-body">
        <p>
          {taskGroupName
            ? t("tasks.modals.removeTaskGroup.messageNamed", {
                name: taskGroupName,
              })
            : t("tasks.modals.removeTaskGroup.message")}
        </p>
        <p className="remove-warning">
          {openTaskCount > 0 ? (
            <Trans
              i18nKey="tasks.modals.removeTaskGroup.warningOpenTasks"
              count={openTaskCount}
              components={{ bold: <strong /> }}
            />
          ) : (
            t("tasks.modals.removeTaskGroup.warning")
          )}
        </p>
      </div>
      <div className="modal-form-buttons">
        <button className="modal-button cancel" onClick={cancelRemoveTaskGroup}>
          {t("common.cancel")}
        </button>
        <button className="modal-button delete" onClick={removeTaskGroup}>
          {t("common.remove")}
        </button>
      </div>
    </div>
  );
}

export default RemoveTaskGroup;
